import {
    REQUEST_TAX_ENTRIES,
    RECEIVE_TAX_ENTRIES,
    UPDATE_TAX_ENTRIES,
    ERROR_TAX_ENTRIES
} from '../types'
import {fetchUrl} from '../../constants/constants'
import {requestItem, receiveItem, failedItem, reloadDashboard} from "../actions"
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import axios from 'axios'
import prepareFilters from "../../helpers/prepareFilters";

function request() {
    return {
        type: REQUEST_TAX_ENTRIES
    };
}

export function receive(data) {
    return {
        type: RECEIVE_TAX_ENTRIES,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_TAX_ENTRIES,
        errors: data
    }
}

function update(data, id, updateType) {
    return {
        type: UPDATE_TAX_ENTRIES,
        id,
        payload: data,
        updateType
    }
}

export function getTaxEntries(params = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().taxEntry, !force)) {
            dispatch(request())
            return axios({
                method: 'GET',
                url: fetchUrl + 'tax-entries',
                params: prepareFilters(params, getState(), "taxEntries")
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function getTaxEntry(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('taxEntry'))
            return axios({
                method: 'GET',
                url: fetchUrl + 'tax-entries/' + id
            }).then(res => {
                dispatch(receiveItem(res.data.data))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function createTaxEntry(data) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'POST',
                url: fetchUrl + 'tax-entries',
                data
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_created'))
                dispatch(update(res.data.data, false, 'create'))
                dispatch(reloadDashboard())
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function updateTaxEntry(data, id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('taxEntry'))
            return axios({
                method: 'PUT',
                url: fetchUrl + 'tax-entries/' + id,
                data
            }).then(res => {
                dispatch(receiveItem(res.data.data, 'message.item_updated'))
                dispatch(update(res.data.data, id, 'update'))
                dispatch(reloadDashboard())
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function deleteTaxEntry(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'DELETE',
                url: fetchUrl + 'tax-entries/' + id
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_deleted'))
                dispatch(update(res.data.data, id, 'delete'))
                dispatch(reloadDashboard())
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}